import { MaxButton, StatusMaxButton } from "components/view/button";
import { AppReducerStateProps, store } from "lib/store";
import { memberActionTypes } from "lib/store/member/reducer";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { prefix } from "lib/worker/client";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { CheckWithPrefix } from "lib/infomation_vender/document";

interface showRuleAgentModalProps {
  state: AppReducerStateProps;
  closeModal: Function;
}

export const showRuleAgentModal = () => {
  store.dispatch({
    type: memberActionTypes.ACTION_OPEN_MODAL_RULE_AGENT,
  });
};

function RuleAgentModal(props: showRuleAgentModalProps) {
  const { closeModal } = props;
  const { isModalRuleAgent } = props.state.member;
  const router = useRouter();
  const [lineid, setlineid] = useState<string | null | undefined>(null);

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: window.location.hostname });
    setlineid(infomations.lineidchat);
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      scrollable={true}
      contentClassName="view-background-transparent"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isModalRuleAgent}
      animation={false}
      onHide={() => {
        if (closeModal) {
          closeModal();
        }
      }}
      dialogClassName="modal-dialog"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title id="example-modal-sizes-title-lg">
          <div className="center-row-content text-bold">
            <span>กติกาตัวแทน</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="margin-top-20">
            <span>ขั้นตอนการเชิญตัวแทน</span>
            <ul>
              <li>ท่านต้องเชิญตัวแทนด้วย Link ที่ทางเราสร้างให้</li>
              <li>
                กดปุ่ม <span>คัดลอก</span> เพื่อนำลิงก์ให้ตัวแทนของท่าน
                เมื่อตัวแทนของท่านกดลิงก์ ระบบจะนำตัวแทนใหม่ไปยังหน้าสมัครสมาชิก
              </li>
              <li>
                เมื่อตัวแทนสมัครสมาชิกด้วยลิงก์แล้ว
                ถือว่าเป็นอันเสร็จสิ้นขั้นตอนแล้ว
              </li>
            </ul>
            <h2 className="margin-top-20">
              <span>สิทธิพิเศษชั้นที่ 1</span>
            </h2>
            <span>ลายละเอียดค่าคอมมิชชั่นได้รับเป็น เครดิต</span>
            <ul>
              <li>ระบบจะทำการคำนวนค่า commission ให้ทุกๆวันที่ 1 ของเดือน</li>
              <li>
                ท่านจะได้รับ <span>เครดิตฟรี</span>{" "}
                ทุกยอดเสียของตัวแทนทั้งหมดของท่าน เช่น <span>RANK</span>{" "}
                ของท่านคือ <span>STARTER</span> จะได้รับค่า commission
                จากยอดเสียของตัวแทนทั้งหมด 5% คือ
                ตัวแทนของท่านมียอดเสียรวมกันทั้งหมด <span>10,000 เครดิต</span>{" "}
                เท่ากับว่าท่านจะได้รับเครดิตฟรี <span>500 เครดิต</span>
              </li>
            </ul>
            <h2 className="margin-top-20">
              <span>สิทธิพิเศษชั้นที่ 2</span>
            </h2>
            <span>ลายละเอียดค่าคอมมิชชั่นได้รับเป็น uDiamond</span>
            <ul>
              <li>ระบบจะอัพเดทข้อมูลให้ตอน 17.00 น. ทุกวัน</li>
              <li>
                ท่านจะได้รับ <span>uDiamond</span> 0.1% จากยอด{" "}
                <span>เทิร์นโอเวอร์</span> ของเพื่อนทั้งหมดของท่าน เช่น
                เพื่อนทั้งหมดทำยอด <span>เทิร์นโอเวอร์</span> 100,000
                ท่านจะได้รับค่าคอมมิชชั่น คือ 100 uDiamond
              </li>
              <li>
                ค่าคอมมิชชั่นจะถูกโอนให้ท่านในรูปแบบ <span>uDiamond</span>{" "}
                ในระบบ
              </li>
              <li>
                หากสงสัยหรือมีคำถามสามารถติดต่อเจ้าหน้าที่ผ่านทางแชท{" "}
                {router.pathname.includes("contact") == false && (
                  <div>
                    {lineid != null ? (
                      <Link href={lineid}>
                        <a>
                          <span>คลิก</span>
                        </a>
                      </Link>
                    ) : (
                      <Link href={`/contact/${prefix}`}>
                        <a>
                          <span>คลิก</span>
                        </a>
                      </Link>
                    )}
                  </div>
                )}
              </li>
            </ul>
            <span>ลายละเอียดการเลื่อนระดับ RANK</span>
            <ul>
              <li>
                ระบบจะทำการคำนวน <span>RANK</span> ให้ทุกๆวันที่ 1 ของเดือน
              </li>
              <li>
                เมื่อ <span>EXP</span> ของท่านถึงระดับที่กำหนดจะเลื่อนระดับทันที
              </li>
              <li>
                <span>EXP</span> สามารถเพิ่มได้จากยอดเสียของตัวแทนทั้งหมด
              </li>
              <li>
                <span>RANK STARTER</span> จะได้รับค่าคอมมิชชั่น 5% และ{" "}
                <span>RANK GLOROIUS</span> คือ <span>RANK</span>{" "}
                สูงที่สุดจะได้รับค่าคอมมิชชั่น 10%
              </li>
              <li>
                ท่านจะได้รับเครดิตเพิ่มมากขึ้นตามลำดับ <span>RANK</span> ของท่าน
                และได้รับเครดิตฟรีสูงสุด 10%
              </li>
            </ul>

            <span>ยอดเสีย คืออะไร?</span>
            <ul>
              <li>
                คือจำนวนเครดิตที่ตัวแทนของท่านแพ้การเดิมพัน จะใช้เพื่อเพิ่มคะแนน
                <span>EXP</span> ของท่าน
              </li>
            </ul>

            <span>RANK คืออะไร?</span>
            <ul>
              <li>
                ตำแหน่งของท่าน เริ่มแรกจะได้รับค่าคอมมิชชั่น 5% และ{" "}
                <span>RANK</span> สูงสุดจะได้รับค่าคอมมิชชั่น 10%
                จากยอดเสียของตัวแทนทั้งหมด
              </li>
            </ul>

            <span>EXP คืออะไร?</span>
            <ul>
              <li>
                <span>EXP</span> สามารถเพิ่มได้จากยอดเสียของตัวแทนทั้งหมด เมื่อ
                EXP ถึงจุดที่กำหนดระบบจะทำการเลื่อนระดับ <span>RANK</span>{" "}
                ของท่านทุกวันที่ 1 ของเดือน
              </li>
            </ul>
            <span>uDiamond คืออะไร?</span>
            <ul>
              <li>
                คะแนนที่ใช้ในระบบ สามารถนำไปแลกเป็นเครดิตได้ และ
                เล่นกิจกรรมอื่นๆภายในเว็บ
              </li>
            </ul>
            <span>วิธีการรับเครดิตฟรี</span>
            <ul>
              <li>
                กดรับเครดิตฟรีได้จากแท็บ <span>รางวัลตัวแทน</span> โดยกดที่ปุ่ม{" "}
                <span>รับ</span> เพื่อรับเครดิตฟรีจากตัวแทน ทุกเดือน
              </li>
            </ul>
            <p className="font-red">
              *นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
              หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <MaxButton
          className="margin-top-10"
          title="ปิด"
          status={StatusMaxButton.submit}
          onClick={() => {
            closeModal();
          }}
        ></MaxButton>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => {
      dispatch({
        type: memberActionTypes.ACTION_CLOSE_MODAL_RULE_AGENT,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RuleAgentModal);
